import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class OaErrorHandler implements ErrorHandler {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public handleError(error: any) {
        throw error;
    }
}
